const toDateTime = (sec) => {
  const t = new Date(1970, 0, 1); // Epoch
  t.setSeconds(sec);
  return t;
};
module.exports = toDateTime;
